// import React, { useState } from 'react';

// const vehicleData = [
//   { name: "Innova Crysta", imgSrc: "/images/gallery/crysta.jpg" },
//   { name: "Aura", imgSrc: "/images/gallery/aura.jpg" },
//   { name: "Dzire", imgSrc: "/images/gallery/dzire.jpg" },
//   { name: "Ertiga", imgSrc: "/images/gallery/ertiga.jpg" },
//   { name: "Urbania", imgSrc: "/images/gallery/urbania.jpg" },
//   { name: "17 Seater Tempo Traveller", imgSrc: "/images/gallery/17-seater-tempo-traveller.jpg" },
//   { name: "20 Seater Tempo Traveller", imgSrc: "/images/gallery/20-seater-tempo-traveller.jpg" },
//   { name: "32 Seater Bus", imgSrc: "/images/gallery/32-seater-bus.jpg" },
//   { name: "35 Seater Bus", imgSrc: "/images/gallery/35-seater-bus.jpg" },
//   { name: "40 Seater Bus", imgSrc: "/images/gallery/40-seater-bus.jpg" },
//   { name: "45 Seater Bus", imgSrc: "/images/gallery/45-seater-bus.jpg" },
// ];


// const GallerySection = () => {
//   const [selectedImage, setSelectedImage] = useState(null);
//   const [currentIndex, setCurrentIndex] = useState(0);

//   const openModal = (index) => {
//     setSelectedImage(vehicleData[index]);
//     setCurrentIndex(index);
//   };

//   const closeModal = () => {
//     setSelectedImage(null);
//   };

//   const nextImage = () => {
//     const nextIndex = (currentIndex + 1) % vehicleData.length;
//     setSelectedImage(vehicleData[nextIndex]);
//     setCurrentIndex(nextIndex);
//   };

//   const prevImage = () => {
//     const prevIndex = (currentIndex - 1 + vehicleData.length) % vehicleData.length;
//     setSelectedImage(vehicleData[prevIndex]);
//     setCurrentIndex(prevIndex);
//   };
 

  
  
  
//     return (
      
//       <div>
  
//     <div className="page-headder bg-section parallaxie">
//         <div className="container">
//           <div className="row">
//             <div className="col-lg-12">
//               <div className="page-header-box text-white">
//                 <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
//                   Gallery
//                 </h1>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>


//       <section className=" gallery-section px-md-2 px-lg-4 p-0">
//         <div className='container-fluid px-0'>

//         <div className="gallery-container row g-0" style={{ display: 'flex', flexWrap: 'wrap' }}>
//           {vehicleData.map((vehicle, index) => (
//             <div
//               key={index}
//               className="gallery-card col-12 col-md-4 col-lg-4"
//               onClick={() => openModal(index)}
//               style={{ position: 'relative', cursor: 'pointer' }}
//             >
//               <img
//                 src={vehicle.imgSrc}
//                 alt={vehicle.name}
//                 style={{ width: '100%', height: 'auto', display: 'block' }}
//               />
//               <div className="overlay" style={{
//                 position: 'absolute',
//                 top: 0,
//                 left: 0,
//                 right: 0,
//                 bottom: 0,
//                 background: 'rgba(0, 0, 0, 0.5)',
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//                 opacity: 0,
//                 transition: 'opacity 0.3s',
//                 color: '#fff',
//                 fontSize: '2rem',
//                 zIndex: 1, // Ensure overlay is above the image
//               }}>
//                 +
//               </div>
//               <div style={{
//                 position: 'absolute',
//                 top: 0,
//                 left: 0,
//                 right: 0,
//                 bottom: 0,
//                 zIndex: 2,
//               }}
//               onMouseEnter={(e) => {
//                 const overlay = e.currentTarget.previousElementSibling;
//                 overlay.style.opacity = '1';
//               }}
//               onMouseLeave={(e) => {
//                 const overlay = e.currentTarget.previousElementSibling;
//                 overlay.style.opacity = '0';
//               }}
//               />
//             </div>
//           ))}
//         </div>

//         {selectedImage && (
//           <div
//             className="modal"
//             style={{
//               position: 'fixed',
//               top: 0,
//               left: 0,
//               width: '100%',
//               height: '100%',
//               background: 'rgba(0, 0, 0, 0.8)',
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               zIndex: 1000,
//             }}
//           >
//             <div className="modal-content w-50" style={{ textAlign: 'center', position: 'relative' }}>
//               <span className="modal-close" onClick={closeModal} style={{
//                 position: 'absolute',
//                 top: '10px',
//                 right: '10px',
//                 cursor: 'pointer',
//                 fontSize: '2rem',
//                 color: 'black',
                
//               }}>×</span>
//               <img src={selectedImage.imgSrc} alt={selectedImage.name} style={{ width: '100%', height: 'auto' }} />
//               <div style={{
//                 display: 'flex',
//                 justifyContent: 'space-between',
//                 position: 'absolute',
//                 bottom: '0',
//                 width: '100%',
//               }}>
//                 <button className="modal-prev" onClick={prevImage} style={{ fontSize: '2rem', cursor: 'pointer', background: 'transparent', border: 'none', color: 'black' }}>‹</button>
//                 <button className="modal-next" onClick={nextImage} style={{ fontSize: '2rem', cursor: 'pointer', background: 'transparent', border: 'none', color: 'black' }}>›</button>
//               </div>
//             </div>
//           </div>
//         )}
//         </div>

//       </section>
//     </div>
//   );
// };

// export default GallerySection;










// import React, { useState } from 'react';

// const vehicleData = [
//   { name: "Innova Crysta", imgSrc: "/images/gallery/crysta.jpg" },
//   { name: "Aura", imgSrc: "/images/gallery/aura.jpg" },
//   { name: "Dzire", imgSrc: "/images/gallery/dzire.jpg" },
//   { name: "Ertiga", imgSrc: "/images/gallery/ertiga.jpg" },
//   { name: "Urbania", imgSrc: "/images/gallery/urbania.jpg" },
//   { name: "17 Seater Tempo Traveller", imgSrc: "/images/gallery/17-seater-tempo-traveller.jpg" },
//   { name: "20 Seater Tempo Traveller", imgSrc: "/images/gallery/20-seater-tempo-traveller.jpg" },
//   { name: "32 Seater Bus", imgSrc: "/images/gallery/32-seater-bus.jpg" },
//   { name: "35 Seater Bus", imgSrc: "/images/gallery/35-seater-bus.jpg" },
//   { name: "40 Seater Bus", imgSrc: "/images/gallery/40-seater-bus.jpg" },
//   { name: "45 Seater Bus", imgSrc: "/images/gallery/45-seater-bus.jpg" },
// ];

// const GallerySection = () => {
//   const [selectedImage, setSelectedImage] = useState(null);
//   const [currentIndex, setCurrentIndex] = useState(0);

//   const openModal = (index) => {
//     setSelectedImage(vehicleData[index]);
//     setCurrentIndex(index);
//   };

//   const closeModal = () => {
//     setSelectedImage(null);
//   };

//   const nextImage = () => {
//     const nextIndex = (currentIndex + 1) % vehicleData.length;
//     setSelectedImage(vehicleData[nextIndex]);
//     setCurrentIndex(nextIndex);
//   };

//   const prevImage = () => {
//     const prevIndex = (currentIndex - 1 + vehicleData.length) % vehicleData.length;
//     setSelectedImage(vehicleData[prevIndex]);
//     setCurrentIndex(prevIndex);
//   };

//   return (
//     <div>
//       {/* Page Header */}
      // <div className="page-headder bg-section parallaxie">
      //   <div className="container">
      //     <div className="row">
      //       <div className="col-lg-12">
      //         <div className="page-header-box text-white">
      //           <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
      //             Gallery
      //           </h1>
      //         </div>
      //       </div>
      //     </div>
      //   </div>
      // </div>

//       {/* Gallery Section */}
//       <section className="gallery-section px-md-2 px-lg-4 p-0">
//         <div className='container-fluid px-0'>
//           <div className="gallery-container row g-0">
//             {vehicleData.map((vehicle, index) => (
//               <div
//                 key={index}
//                 className="gallery-card col-12 col-md-4 col-lg-4"
//                 onClick={() => openModal(index)}
//                 style={{ position: 'relative', cursor: 'pointer' }}
//               >
//                 <img
//                   src={vehicle.imgSrc}
//                   alt={vehicle.name}
//                   style={{ width: '100%', height: 'auto', display: 'block' }}
//                 />
                
//                 {/* Overlay */}
//                 <div className="overlay" style={{
//                   position: 'absolute',
//                   top: 0,
//                   left: 0,
//                   right: 0,
//                   bottom: 0,
//                   background: 'rgba(0, 0, 0, 0.5)',
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center',
//                   opacity: 0,
//                   transition: 'opacity 0.3s',
//                   color: '#fff',
//                   fontSize: '2rem',
//                   zIndex: 1,
//                 }}>
//                   +
//                 </div>

//                 {/* Hover area */}
//                 <div style={{
//                   position: 'absolute',
//                   top: 0,
//                   left: 0,
//                   right: 0,
//                   bottom: 0,
//                   zIndex: 2,
//                 }}
//                   onMouseEnter={(e) => {
//                     const overlay = e.currentTarget.previousElementSibling;
//                     overlay.style.opacity = '1';
//                   }}
//                   onMouseLeave={(e) => {
//                     const overlay = e.currentTarget.previousElementSibling;
//                     overlay.style.opacity = '0';
//                   }}
//                 />
//               </div>
//             ))}
//           </div>

//           {/* Modal */}
//           {selectedImage && (
//             <div
//               className="modal"
//               style={{
//                 position: 'fixed',
//                 top: 0,
//                 left: 0,
//                 width: '100%',
//                 height: '100%',
//                 background: 'rgba(0, 0, 0, 0.8)',
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//                 zIndex: 1000,
//               }}
//             >
//               <div className="modal-content w-50" style={{ textAlign: 'center', position: 'relative' }}>
//                 <span className="modal-close" onClick={closeModal} style={{
//                   position: 'absolute',
//                   top: '10px',
//                   right: '10px',
//                   cursor: 'pointer',
//                   fontSize: '2rem',
//                   color: 'white',
//                 }}>×</span>
                
//                 <img src={selectedImage.imgSrc} alt={selectedImage.name} style={{ width: '100%', height: 'auto' }} />

//                 {/* Navigation */}
//                 <div style={{
//                   display: 'flex',
//                   justifyContent: 'space-between',
//                   position: 'absolute',
//                   bottom: '0',
//                   width: '100%',
//                   padding: '0 10px 10px 10px'
//                 }}>
//                   <button className="modal-prev" onClick={prevImage} style={{
//                     fontSize: '2rem',
//                     cursor: 'pointer',
//                     background: 'transparent',
//                     border: 'none',
//                     color: 'white'
//                   }}>‹</button>
//                   <button className="modal-next" onClick={nextImage} style={{
//                     fontSize: '2rem',
//                     cursor: 'pointer',
//                     background: 'transparent',
//                     border: 'none',
//                     color: 'white'
//                   }}>›</button>
//                 </div>
//               </div>
//             </div>
//           )}
//         </div>
//       </section>
//     </div>
//   );
// };

// export default GallerySection;










import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
const Gallery = () => {
  // Sample images with unique ids and different src/alt values
  const images = [



  { name: "1", src: "/images/gallery/1.jpeg" },
  { name: "2", src: "/images/gallery/2.jpeg" },
  { name: "3", src: "/images/gallery/3.jpeg" },
  { name: "4", src: "/images/gallery/4.jpeg" },
  { name: "5", src: "/images/gallery/5.jpeg" },
  { name: "6", src: "/images/gallery/6.jpeg" },
  { name: "7", src: "/images/gallery/7.jpeg" },
  { name: "8", src: "/images/gallery/8.jpeg" },
  { name: "9", src: "/images/gallery/9.jpeg" },
  { name: "10", src: "/images/gallery/10.jpeg" },
  { name: "11", src: "/images/gallery/11.jpeg" },
  { name: "12", src: "/images/gallery/12.jpeg" },
  { name: "13", src: "/images/gallery/13.jpeg" },
  { name: "14", src: "/images/gallery/14.jpeg" },
  { name: "15", src: "/images/gallery/15.jpeg" },
  { name: "16", src: "/images/gallery/16.jpeg" },
  { name: "17", src: "/images/gallery/17.jpeg" },
  { name: "18", src: "/images/gallery/18.jpeg" },
  { name: "19", src: "/images/gallery/19.jpeg" },
  { name: "20", src: "/images/gallery/20.jpeg" },
  { name: "21", src: "/images/gallery/21.jpeg" },
  { name: "22", src: "/images/gallery/22.jpeg" },
  { name: "23", src: "/images/gallery/23.jpeg" },
  { name: "24", src: "/images/gallery/24.jpeg" },
  { name: "25", src: "/images/gallery/25.jpeg" },
  { name: "26", src: "/images/gallery/26.jpeg" },
  { name: "27", src: "/images/gallery/27.jpeg" },
  { name: "28", src: "/images/gallery/28.jpeg" },
  { name: "29", src: "/images/gallery/29.jpeg" },
  { name: "30", src: "/images/gallery/30.jpeg" },
  { name: "31", src: "/images/gallery/31.jpeg" },
  { name: "32", src: "/images/gallery/32.jpeg" },
  { name: "33", src: "/images/gallery/33.jpeg" },
  { name: "34", src: "/images/gallery/34.jpeg" },
  { name: "35", src: "/images/gallery/35.jpeg" },
  { name: "36", src: "/images/gallery/36.jpeg" },
  { name: "37", src: "/images/gallery/37.jpeg" },
  { name: "38", src: "/images/gallery/38.jpeg" },
  { name: "39", src: "/images/gallery/39.jpeg" },
  { name: "40", src: "/images/gallery/40.jpeg" },
  { name: "41", src: "/images/gallery/41.jpeg" },
  { name: "42", src: "/images/gallery/42.jpeg" },
  { name: "43", src: "/images/gallery/43.jpeg" },
  { name: "44", src: "/images/gallery/44.jpeg" },
  { name: "45", src: "/images/gallery/45.jpeg" },
  { name: "46", src: "/images/gallery/46.jpeg" },
  { name: "47", src: "/images/gallery/47.jpeg" },
  { name: "48", src: "/images/gallery/48.jpeg" },
  { name: "49", src: "/images/gallery/49.jpeg" },
  { name: "50", src: "/images/gallery/50.jpeg" },
  { name: "51", src: "/images/gallery/51.jpeg" },
  { name: "52", src: "/images/gallery/52.jpeg" },
  { name: "53", src: "/images/gallery/53.jpeg" },
  { name: "54", src: "/images/gallery/54.jpeg" },
  { name: "55", src: "/images/gallery/55.jpeg" },
  { name: "56", src: "/images/gallery/56.jpeg" },
  { name: "57", src: "/images/gallery/57.jpeg" },
  { name: "58", src: "/images/gallery/58.jpeg" },
  { name: "59", src: "/images/gallery/59.jpeg" },
  { name: "60", src: "/images/gallery/60.jpeg" },
  { name: "61", src: "/images/gallery/61.jpeg" },
  { name: "62", src: "/images/gallery/62.jpeg" },
  { name: "63", src: "/images/gallery/63.jpeg" },
  { name: "64", src: "/images/gallery/64.jpeg" },
  { name: "65", src: "/images/gallery/65.jpeg" },
  { name: "66", src: "/images/gallery/66.jpeg" },
  { name: "67", src: "/images/gallery/67.jpeg" },
  { name: "68", src: "/images/gallery/68.jpeg" },
  { name: "69", src: "/images/gallery/69.jpeg" },
  { name: "70", src: "/images/gallery/70.jpeg" },
  { name: "71", src: "/images/gallery/71.jpeg" },
  { name: "72", src: "/images/gallery/72.jpeg" },
  { name: "73", src: "/images/gallery/73.jpeg" },
  { name: "74", src: "/images/gallery/74.jpeg" },


  { name: "Innova Crysta", src: '/images/gallery/crysta.jpg' },
  { name: "Aura", src: '/images/gallery/aura.jpg' },
  { name: "Dzire", src: '/images/gallery/dzire.jpg' },
  { name: "Ertiga", src: '/images/gallery/ertiga.jpg' },
  { name: "Urbania", src: '/images/gallery/urbania.jpg' },
  { name: "17 Seater Tempo Traveller", src: '/images/gallery/17-seater-tempo-traveller.jpg' },
  { name: "20 Seater Tempo Traveller", src: '/images/gallery/20-seater-tempo-traveller.jpg' },
  { name: "32 Seater Bus", src: '/images/gallery/32-seater-bus.jpg' },
  { name: "35 Seater Bus", src: '/images/gallery/35-seater-bus.jpg' },
  { name: "40 Seater Bus", src: '/images/gallery/40-seater-bus.jpg' },
  { name: "45 Seater Bus", src: '/images/gallery/45-seater-bus.jpg' },


   
  ];

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  // Open modal and set the clicked image
  const openModal = (index) => {
    setCurrentImageIndex(index);
    setIsModalOpen(true);
  };

  // Close modal
  const closeModal = () => {
    setIsModalOpen(false);
  };

  // Show next image in the modal
  const nextImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

  // Show previous image in the modal
  const prevImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  

  
  return (

<>



      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  Gallery
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
    
    <div className="gallery-container ">
      <div className="gallery-grid ">
        {images.map((image, index) => (
          <img
            key={image.id}
            src={image.src}
            alt={image.alt}
            className="gallery-image-item borderrr "
            onClick={() => openModal(index)} // Open the modal on click
          />
        ))}
      </div>

      {/* Modal */}
      {isModalOpen && (
        <div className="modal-overlay">
          <button className="modal-close-button" onClick={closeModal}>
            &times;
          </button>
          <div className="modal-content-container">
            <button className="modal-prev-button" onClick={prevImage}>
              &#10094;
            </button>
            <div className="modal-image-container ">
              <img
                src={images[currentImageIndex].src}
                alt={images[currentImageIndex].alt}
                className="modal-image borderrr"
              />
            </div>
            <button className="modal-next-button" onClick={nextImage}>
              &#10095;
            </button>
          </div>
        </div>
      )}
    </div>

</>
  );
};

export default Gallery;